export default "__VITE_ASSET__4529fba8__"